import ApiError from '../../../../entities/api-error/ApiError'
import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestCreateLabels {
  type: DashboardActionTypes.REQUEST_CREATE_LABELS;
  payload: {
    products: OrderProduct[]
  }
}

export function requestCreateLabels({
  products,
}: RequestCreateLabels['payload']): RequestCreateLabels {
  return {
    type: DashboardActionTypes.REQUEST_CREATE_LABELS,
    payload: {
      products,
    },
  }
}

export interface RequestCreateLabelsSuccess {
  type: DashboardActionTypes.REQUEST_CREATE_LABELS_SUCCESS;
  payload: {
    products: OrderProduct[]
  }
}

export function requestCreateLabelsSuccess({
  products,
}: RequestCreateLabelsSuccess['payload']): RequestCreateLabelsSuccess {

  return {
    type: DashboardActionTypes.REQUEST_CREATE_LABELS_SUCCESS,
    payload: {
      products,
    },
  }
}

export interface RequestCreateLabelsFailure {
  type: DashboardActionTypes.REQUEST_CREATE_LABELS_FAILURE;
  payload: {
    products:  OrderProduct[]
    error:    ApiError;
  }
}

export function requestCreateLabelsFailure({
  products,
 error,
}: RequestCreateLabelsFailure['payload']): RequestCreateLabelsFailure {

  return {
    type: DashboardActionTypes.REQUEST_CREATE_LABELS_FAILURE,
    payload: {
      products,
      error,
    },
  }
}
